const Style = {
    page: 'flex min-h-0 flex-1 flex-col gap-3',
    card: 'w-full',
    toolbar:
        'flex shrink-0 flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4',
    toolbarCopy: 'min-w-0 flex-1',
    embedTitle: 'text-base font-semibold text-text-primary',
    inviteBtn: 'h-9 w-full shrink-0 self-end sm:w-auto sm:self-center',
    body: 'min-w-0',
};

export default Style;
